<template>
  <v-container fluid>
    <v-btn color="blue" @click="createNewParam()">Adicionar novo dominio</v-btn>
    <template v-if="config.domains">
      <v-card class="my-4">
        <v-card-title>
          Parametros
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchParams"
            append-icon="fas fa-search"
            label="Pesquisa"
            single-line
            clearable
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          style="cursor: pointer;"
          :headers="[
            { text: 'Nome', value: 'name' },
            { text: 'Domínio', value: 'domain' }
          ]"
          :items="config.domains"
          item-key="domain"
          class="elevation-1"
          @click:row="editParam"
          :search="searchParams"
        ></v-data-table>
      </v-card>
    </template>
    <p>
      Os parametros só serão salvos no servidor se você clicar em salvar. Caso
      tenha feito alguma configuração errada e queira recarregar os parametros
      originais, clique em recarregar.
    </p>
    <p>
      Para fechar a janela SEM SALVAR clique em "fechar" mas atenção: Se fechar
      a janela sem salvar os dados, estes não serão usados e serão pedidos ao
      recarregar a página.
    </p>
    <v-btn color="red" @click="fetchMe()"
      ><v-icon class="mr-2">fas fa-sync</v-icon> Recarregar</v-btn
    >
    <v-btn color="warning" @click="$emit('close')"
      ><v-icon class="mr-2">fas fa-times</v-icon>Fechar</v-btn
    >
    <v-btn color="success" @click="saveParams()"
      ><v-icon class="mr-2">fas fa-save</v-icon>Salvar</v-btn
    >
    <v-dialog
      v-model="dialogs.newParam"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogs.newParam = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Novo domínio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="addNewParam()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container class="mx-2">
          <v-btn v-if="editingParam" color="red" @click="removeParam"
            >Remover parametro</v-btn
          >
          <p>
            <span class="title">1. </span>
            <span>Primeiro digite um nome para identificar o parametro</span>
          </p>
          <div class="mx-5">
            <v-text-field
              label="Nome (apenas um identificador do parametro)"
              v-model="newParam.name"
            ></v-text-field>
          </div>

          <p>
            <span class="title">2. </span>
            <span class="red--text text--lighten-1"
              ><i>url do dominio (SEM HTTPS:// ex: site.com.br)</i></span
            >
          </p>
          <div class="mx-5">
            <v-text-field
              label="Domínio"
              v-model="newParam.domain"
            ></v-text-field>
          </div>

          <p>
            <span class="title">3. </span>
            <span>Regras e lista de parametros</span>
          </p>
          <div class="mx-5">
            <v-select
              v-model="newParam.newParameterRule"
              :items="newParameterRule"
              item-value="id"
              item-text="text"
              label="Regra de novos parametros"
            ></v-select>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="green"
                  @click="
                    newParam.parameters.push({
                      name: null,
                      value: null,
                      rule: 0
                    })
                  "
                  ><v-icon>fas fa-plus</v-icon></v-btn
                >
              </template>
              <span>Adicionar nova regra</span>
            </v-tooltip>
            <v-row
              align="center"
              v-for="(p, ixP) in newParam.parameters"
              :key="'cfg_params' + ixP"
            >
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col v-if="p.type === 0 && p.rule === 1" cols="12">
                ex: {{ newParam.domain }}/?<b>{{ p.name }}</b
                >=<b>{{ p.value }}</b>
              </v-col>
              <v-col v-if="p.type === 1" cols="12">
                ex: {{ newParam.domain
                }}<span
                  v-for="(_x, _ixx) in [
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par',
                    'par'
                  ]"
                  :key="'parsuburl_' + _ixx"
                  >/<span v-if="p.order == _ixx + 1"
                    ><b>{{ p.value }}</b></span
                  ><span v-else>{{ _x }}</span></span
                >
              </v-col>

              <v-col>
                <v-select
                  v-model="p.type"
                  :items="parameterTypes"
                  item-value="id"
                  item-text="text"
                  label="Tipo de parametro"
                ></v-select>
              </v-col>
              <v-col v-if="p.type === 0">
                <v-text-field
                  v-model="p.name"
                  label="NOME"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col v-if="p.type === 0">
                <v-text-field
                  v-model="p.value"
                  label="VALOR"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col v-if="p.type === 0">
                <v-select
                  v-model="p.rule"
                  :items="rules"
                  item-value="id"
                  item-text="text"
                  label="Regra"
                ></v-select>
              </v-col>
              <v-col v-if="p.type === 1">
                <v-text-field
                  v-model="p.order"
                  label="Ordem (ex.com/1/2/3/4/5/etc..)"
                  type="number"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col v-if="p.type === 1">
                <v-text-field
                  v-model="p.value"
                  label="Texto a ser substituido"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col class="text-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="red"
                      @click="newParam.parameters.splice(ixP, 1)"
                      ><v-icon>fas fa-minus</v-icon></v-btn
                    >
                  </template>
                  <span>Remover regra</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>

          <p>
            <span class="title">4. </span>
            <span class="red--text text--lighten-1"><i>Concatenar url</i></span>
          </p>
          <div class="mx-5">
            <v-text-field
              label="Antes"
              v-model="newParam.concatBefore"
              single-line
              style="max-width: 200px; display: inline-block;"
            ></v-text-field>
            <v-icon style="display: inline;" class="ml-2 mr-2"
              >fas fa-plus</v-icon
            >
            https://{{ newParam.domain }}/?p=123etc...
            <v-icon style="display: inline;" class="ml-2 mr-2"
              >fas fa-plus</v-icon
            >
            <v-text-field
              label="Depois"
              v-model="newParam.concatAfter"
              single-line
              style="max-width: 200px; display: inline-block;"
            ></v-text-field>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'parametros',
  components: {},
  data() {
    return {
      config: {},
      searchParams: '',
      editingParam: false,
      newParam: {
        name: '',
        domain: '',
        parameters: [],
        newParameterRule: 0,
        concatBefore: null,
        concatAfter: null
      },
      dialogs: {
        newParam: false
      },
      parameterTypes: [
        { id: 0, text: 'PARAMETRO' },
        { id: 1, text: 'CAMINHO' }
      ],
      rules: [
        { id: 0, text: 'Ignorar a regra atual' },
        { id: 1, text: 'Substituir pelo valor atual' },
        { id: 2, text: 'Excluir parametro do link' }
      ],
      newParameterRule: [
        {
          id: 0,
          text:
            'Manter todos os eventuais parametros que não estiverem listados'
        },
        {
          id: 1,
          text:
            '[Whitelist] Manter somente os parametros aqui listados e remover os novos'
        }
      ]
    }
  },
  methods: {
    saveParams() {
      var vm = this
      vm.$API
        .Request('put', 'setConfig', { data: JSON.stringify(vm.config) })
        .then(result => {
          console.debug(result.data)
          vm.$snotify.success(`Configurações salvas com sucesso`)
          vm.$emit('saveParams', vm.config)
        })
        .catch(error => {
          vm.$snotify.error(`Erro ao salvar configurações: ${error.message}`)
          console.debug(error)
        })
    },
    createNewParam() {
      var vm = this
      vm.newParam = {
        name: null,
        domain: null,
        parameters: [],
        newParameterRule: 0,
        concatBefore: null,
        concatAfter: null
      }
      vm.editingParam = false
      vm.dialogs.newParam = true
    },
    addNewParam() {
      var vm = this
      let _edit = false
      if (vm.config && !Array.isArray(vm.config.domains)) {
        vm.config.domains = []
      }
      vm.config.domains.forEach(_d => {
        if (_d.domain === vm.newParam.domain) {
          _d = vm.newParam
          vm.$snotify.info(`Parametro editado com sucesso`)
          _edit = true
        }
      })
      if (!_edit) {
        vm.config.domains.push(vm.newParam)
        vm.$snotify.success(`Novo parametro adicionado com sucesso`)
      }
      vm.newParam = {
        name: null,
        domain: null,
        parameters: [],
        newParameterRule: 0
      }
      vm.editingParam = false
      vm.dialogs.newParam = false
    },
    removeParam() {
      var vm = this
      let _ixToRemove = null
      for (let _ixP = 0; _ixP < vm.config.domains.length; _ixP++) {
        const _domain = vm.config.domains[_ixP]
        if (_domain.domain === vm.newParam.domain) {
          _ixToRemove = _ixP
          break
        }
      }
      if (_ixToRemove !== null) {
        vm.config.domains.splice(_ixToRemove, 1)
        vm.$snotify.warning(`Parametro removido com sucesso`)
        vm.newParam = {
          name: null,
          domain: null,
          parameters: [],
          newParameterRule: 0,
          concatBefore: null,
          concatAfter: null
        }
        vm.editingParam = false
        vm.dialogs.newParam = false
      } else {
        vm.$snotify.error(
          `Nenhum parametro encontrado para ser removido. Para remover um parametro existente, clique no parametro para editar e em seguida remova-o`
        )
      }
    },
    editParam(_p) {
      var vm = this
      vm.newParam = _p
      vm.editingParam = true
      vm.dialogs.newParam = true
    },
    fetchMe() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `me`)
          .then(result => {
            if (result && result.configurations) {
              if (result.configurations.link_rules) {
                vm.config = JSON.parse(result.configurations.link_rules)
              }
            }
            console.debug(result)
            resolve(true)
          })
          .catch(error => {
            vm.$snotify.error(
              `Erro ao consultar configurações: ${error.message}`
            )
            console.debug(error)
            reject(error)
          })
      })
    }
  },
  created() {
    // Get all informations and update it
    var vm = this
    vm.fetchMe()
  },
  mounted() {}
}
</script>
